import { render, staticRenderFns } from "./BaseDataTableTableCell.vue?vue&type=template&id=489eb06a"
import script from "./BaseDataTableTableCell.vue?vue&type=script&lang=js"
export * from "./BaseDataTableTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports